export default __webpack_public_path__ + "static/media/legs.6995e2b3.svg";